export default __webpack_public_path__ + "static/media/reload-black.8daadd30.svg";